import { createFileRoute } from '@tanstack/react-router'
import { SignupsPage } from '~/features/admin/signups-page'

export const Route = createFileRoute('/admin/signups')({
  component: SignupsPage,
})
